module.exports = __webpack_public_path__ + "media/icons/arrow-dashboard-link-5270dd6c.svg";